module.exports = __webpack_public_path__ + "img/微信端网页-圆.e693eaaa.png";